import { Loading3QuartersOutlined } from '@ant-design/icons';

export default function Loading(props: { className?: string }): JSX.Element {
  const { className } = props;

  return (
    <span className={className}>
      <Loading3QuartersOutlined spin={true} />
    </span>
  );
}
